var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.donwloadUrl && !_vm.isChannel)?_c('a',{class:_vm.$style.download,attrs:{"href":_vm.donwloadUrl,"target":"_blank"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }